<template>
  <v-card flat>
    <h1 class="display-1 text-center my-5">Stampyt</h1>
    <v-card-text>
      <p class="text-center">
        {{ message }}
      </p>
      <div v-if="!error" class="text-center">
        <span class="link">{{ link }}</span>
        <div class="flex mt-5">
          <CopyClipboardButton copyFrom="ChangeNavigatorAlert" :copy="link" />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import CopyClipboardButton from '@/components/buttons/CopyClipboardButton'

export default {
  name: 'ChangeNavigatorAlert',

  components: {
    CopyClipboardButton
  },

  data() {
    return {
      show: false,
      error: false
    }
  },

  props: {
    room: Object,
    message: String
  },

  created() {
    if (!this.room || !(this.room && this.room.id_live_video)) {
      this.error = true
    }
  },

  computed: {
    link() {
      const id = this.room && this.room.id_live_video
      return document.location.origin + '/videos/live/rooms/' + id
    }
  }
}
</script>

<style lang="sass">
.title
  text-align: center !important
  font-family: 'Fira Sans', sans-serif
  font-size: 30px !important
.link
  color: blue
  text-decoration: underline
.flex
  display: flex
  align-items: center
  justify-content: center
</style>
